import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  ChatCenteredIcon,
  ClockCountdownIcon,
  IconButtonV2,
  PlusPlainIcon,
  SideToolbar,
  StackIcon,
  StackSimpleIcon,
} from '@utilities';

import styles from './_index.module.scss';

const NarrativesNavigation = ({ activePage, onClick }) => {
  return (
    <div>
      <SideToolbar
        tools={[
          <IconButtonV2
            className={activePage === 'landing' || activePage === 'chat' ? styles['active'] : ''}
            icon={<ChatCenteredIcon />}
            key="build-with-chat"
            onClick={() => onClick('chat')}
            tooltip="Build with Chat"
            tooltipProps={{ placement: 'right' }}
            variant="subtle"
          />,
          <IconButtonV2
            className={activePage === 'templates' ? styles['active'] : ''}
            icon={<StackIcon />}
            key="browse-templates"
            onClick={() => onClick('templates')}
            tooltip="Browse Template Library"
            tooltipProps={{ placement: 'right' }}
            variant="subtle"
          />,
          <IconButtonV2
            className={activePage === 'topics' ? styles['active'] : ''}
            icon={<StackSimpleIcon />}
            key="assemble-with-topic-cards"
            onClick={() => onClick('topics')}
            tooltip="Assemble with Topic Cards"
            tooltipProps={{ placement: 'right' }}
            variant="subtle"
          />,
          <IconButtonV2
            className={activePage === 'past-projects' ? styles['active'] : ''}
            icon={<ClockCountdownIcon />}
            key="past-projects"
            onClick={() => onClick('past-projects')}
            tooltip="Past Projects"
            tooltipProps={{ placement: 'right' }}
            variant="subtle"
          />,
        ]}
      />
      <IconButtonV2
        className={classNames(styles['narratives-navigation-plus-button'], {
          [styles['active']]: activePage === 'new-project',
        })}
        icon={<PlusPlainIcon />}
        key="new-project"
        onClick={() => onClick('new-project')}
        tooltip="Create a New Project"
        tooltipProps={{ placement: 'right' }}
      />
    </div>
  );
};

NarrativesNavigation.propTypes = {
  activePage: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NarrativesNavigation;
